<template>
  <div style="width: 100% !important;">
    <div class="foot" style="padding-top: 20px">
      <div v-if="isShow" class="top" style="margin-bottom:30px;text-align: center;">
          <el-row style="margin-bottom:20px;width: 1200px;display: inline-block;">
            <el-col :span="6">
              <select
                v-model="value1"
                @change="selectChange(value1)"
                placeholder="----行业链接----"
                style="width: 258px ;height:30px"
              >
                <option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                </option>
              </select>
            </el-col>
            <el-col :span="6">
              <select
                v-model="value2"
                @change="selectChange(value2)"
                placeholder="----行业链接----"
                style="width: 258px ;height:30px"
              >
                <option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                </option>
              </select>
            </el-col>
            <el-col :span="6">
              <select
                v-model="value3"
                @change="selectChange(value3)"
                placeholder="----行业链接----"
                style="width: 258px ;height:30px"
              >
                <option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
                </option>
              </select>
            </el-col>
            <el-col :span="6">
              <select
                v-model="value4"
                @change="selectChange(value4)"
                placeholder="----行业链接----"
                style="width: 258px ;height:30px"
              >
                <option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
                </option>
              </select>
            </el-col>
          </el-row>
        </div>
      <div class="footMain" style="text-align:center">
        <div style="display:inline-block">
          <div class="Left"><img src="../../assets/image/ewm.jpg" /><br />甘肃二建微信公众号</div>
          <div class="Right footLink">
            <div class="rightText" style="font-size: 14px;">
              <span>版权所有：甘肃第二建设集团有限责任公司 </span>
              <span>
                <a href="https://uweb.umeng.com/v1/login.php?siteid=1279599231" target="_blank" title="站长统计">
                  <img border="0" hspace="0" vspace="0" src="http://icon.cnzz.com/img/pic.gif" />
                </a>
              </span>
              <br />
              <span>地址：兰州市七里河区晏家坪五村一号 邮编：730050</span><br>
              <span>E-mail：Gansuerjianbgs@sohu.com 传真：0931-2394790 电话：0931-2392652</span><br>
              网站ICP备案号：<a href="http://beian.miit.gov.cn" target="_blank" style="color:#FFFFFF">陇ICP备13000342号-1</a>
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010302000267"
                target="_blank"
                style="color:#FFFFFF"
                >&nbsp;&nbsp;&nbsp;&nbsp;公安备案号：62010302000353</a
              >
              <br />
              <div class="enw">本站样式已版权保护，不得镜像与仿制 违者必究   Copyright © 2019  All Rights Reserved.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow:true,
      options1: [
        {
          value: '',
          label: '----内部链接----'
        },
        {
          value: 'http://www.gsjtw.cc/',
          label: '甘肃建投'
        },
        {
          value: 'http://www.gsyj.com.cn/',
          label: '甘肃第一建设集团有限责任公司'
        }
      ],
      value1: '',
      value2: '',
      value3: '',
      value4: '',
      options2: [
        {
          value: '',
          label: '----友情链接----'
        },
      ],
      options3: [
        {
          value: '',
          label: '----行业链接----'
        },
      ],
      options4: [
        {
          value: '',
          label: '----推荐链接----'
        },
      ],
      fullpath:''
    }
  },
  watch:{
    $route(val) {
      var fullpath = val.path.split('/')[1]
      if(fullpath=="homePage"){
        this.isShow = true
      }else{
        this.isShow = false
      }
    }
  },

  mounted() {
    // this.getNum()
  },
  methods: {
    selectChange(value) {
      window.open(value)
    },
  }
}
</script>

<style lang="scss">
.foot{
  .top{
    border-bottom: 1px solid #326891;
    select{
      background-color: rgb(33,75,125);
      color: #ffffff;
      padding-left: 10px;
      font-size: 12px;
      border: 1px solid #9194a7;
    }
  }
}
.foot {
  background-color: rgb(33,75,125);
  color: #ffffff;
  text-align: center;
  line-height: 25px;
}
.footMain {
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}

.footMain .Left {
  float: left;
  overflow: hidden;
  margin-left: 30px;
  line-height: 25px;
  color: #76a6ca;
  text-align: center;
  font-size: 13px;
}

.footMain .Left img {
  width: 157px;
  height: 157px;
  margin-bottom: 20px;
}
.footMain .Right {
  width: 800px;
  float: left;
  margin-left: 60px;
  text-align: left;
  line-height: 40px;
}
.footMain .footLink {
  height: auto;
}
.footMain .footLink .el-input__inner {
  background: none;
  border: 1px solid #9194a7;
  color: #ffffff;
  text-indent: 10px;
  line-height: 30px;
  font-size: 12px;
  height: 30px;
  margin-top: 10px;
  border-radius: 0px;
}
.el-input__suffix {
  position: absolute;
  top: 4px;
  height: 100%;
  color: #ffffff;
  text-align: center;
}
.el-popper[x-placement^='bottom'] {
  margin-top: 8px;
}
.el-select-dropdown {
  border: 1px solid #e4e7ed;
  border-radius: 1px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;
}
.el-select-dropdown__item {
  font-size: 12px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
  cursor: pointer;
}

.el-select-dropdown__item.selected {
  color: #fff;
  background-color: #00b4fe;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #00b4fe;
}
.el-select .el-input .el-select__caret {
  color: #ffffff;
}
a,
a:focus,
a:hover {
  text-decoration: none;
}
a {
  font-family: '微软雅黑', 'Microsoft YaHei', sans-serif;
  font-size: 16px;
  color: #000000;
}
.foot .enw {
  color: #76a6ca;
  text-align: left;
  font-size: 13px;
  display: inline-block;
  width: 100%;
  margin-top: 20px;
}
</style>
